














































import Icon from '@/main-components/common/Icon.vue';
import { Question } from '@/resource/question/question.model';
import { FetchQuestionsParams } from '@/resource/question/questions.store';
import { QuestionLanguage } from '@/resource/subject/subject.model';
import { setCookieSeenTutorialToTrue } from '@/utils/cookie';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

@Component({
  components: { Icon, BeatLoader },
})
export default class QuestionBankButton extends Vue {
  @Inject('colorBrandDarkPrimary')
  colorBrandDarkPrimary!: string;

  @Inject('colorWhitePrimary')
  colorWhitePrimary!: string;

  @Inject('addQuestionToPaper')
  addQuestionToPaper!: (
    questionId: number,
    answerPosition: number,
    isSubjective: boolean,
    languages: QuestionLanguage[],
  ) => Promise<void>;

  @Inject('toggleIsQuestionBankItemLoading')
  toggleIsQuestionBankItemLoading: (value: boolean) => void;

  @Prop({ required: true })
  question: Question;

  @Prop({ required: true })
  isSubjective: boolean;

  @Prop({ required: true })
  questionsFilter: FetchQuestionsParams;

  @Prop({ required: true })
  isQuestionBankItemLoading: boolean;

  @Prop({ default: false })
  answerPosition!: number | null;

  isLoading = false;

  get isDisableAddQuestion() {
    return !this.isLoading && this.isQuestionBankItemLoading;
  }

  async addQuestionClicked() {
    if (this.isLoading || this.isDisableAddQuestion) return;
    this.isLoading = true;
    this.toggleIsQuestionBankItemLoading(true);

    await this.addQuestionToPaper(
      this.question.id,
      this.answerPosition || 0,
      this.isSubjective,
      this.questionsFilter.languages &&
        this.questionsFilter.languages.length === 1
        ? (this.questionsFilter.languages as QuestionLanguage[])
        : this.question.languages,
    );

    this.$sendMpEvent({
      event: this.$mp_value.QuestionAdd,
      properties: {
        chapterName: this.question.chapter.name,
        form: this.question.chapter.form,
        subjectUuid: this.question.chapter.subject.uuid,
      },
    });

    setCookieSeenTutorialToTrue();

    this.toggleIsQuestionBankItemLoading(false);
    this.isLoading = false;
  }
}
